// extracted by mini-css-extract-plugin
export default {"container":"RepeatCustomerBox_container__BY2Fu","circleContainer":"RepeatCustomerBox_circleContainer__QLLfK","circle":"RepeatCustomerBox_circle__3HotT"};